import React, { useEffect, useMemo } from 'react';
import Skeleton from 'react-loading-skeleton';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  DYNAMIC_NAVIGATION_TITLE_MAP,
  DYNAMIC_SUB_TITLE_MAP,
  DYNAMIC_TITLE_MAP,
  STYLES,
} from '../consts';
import { Header } from '../manageComponents/Header';
import Heading from '../../../generic-components/Heading';
import { useGetSupplierData } from '../hooks/useGetSupplierData';
import { PickerWrapper } from '../pickerComponents/PickerWrapper';
import Button from '../../../generic-components/Button';
import { ReactComponent as LeftArrow } from '../../../assets/svg/left-arrow-title.svg';

export const PickSupplier = () => {
  const { state } = useLocation();
  const navigate = useNavigate();

  /** Reqct-Queries */
  const {
    refetch: getSupplierList, data: supplierList, isRefetching: isRefetchSupplierList, isLoading: isLoadingSupplierList,
  } = useGetSupplierData({ });
  /** --- */

  const isLoadingState = useMemo(() => isRefetchSupplierList || isLoadingSupplierList, [isRefetchSupplierList, isLoadingSupplierList]);

  useEffect(() => {
    getSupplierList();
  }, []);

  return (
    <div className={STYLES.PAGE_WRAPPER}>
      <Header title={DYNAMIC_NAVIGATION_TITLE_MAP[state?.referrer]} upperMessage={state?.upperMessage || ''} />
      <div className={STYLES.BODY_WRAPPER}>
        <div className='relative'>
          {(state?.backUrl && state?.desireStep) && (
          <Button
            onClick={() => {
              navigate(state?.backUrl, {
                state: {
                  redirectStep: state?.desireStep,
                },
              });
            }}
            className='absolute left-0 top-0 translate-x-[-220px] translate-y-[3px] py-[6px] pl-[6px] pr-[10px] rounded-[8px] hover:bg-bw02'
            id='elBackButton'
            childElement={(
              <div className='flex items-center gap-[6px]'>
                <LeftArrow className='w-[16px] stroke-bw08' />
                <Heading title='Back' className='border-b border-bw08' />
              </div>
          )}
          />
          )}
          <Heading
            title={DYNAMIC_TITLE_MAP[state?.referrer]}
            className={STYLES.PICKER_TITLE}
          />
        </div>
        <Heading
          title={DYNAMIC_SUB_TITLE_MAP[state?.referrer]}
          className={STYLES.PICKER_SUB_TITLE}
        />
        {isLoadingState ? (
          <div className={STYLES.PICKER_LOADER_SKELETON_WRAPPER}>
            {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => <Skeleton key={i} width='375px' height='58px' />)}
          </div>
        ) : <PickerWrapper desireStep={state?.desireStep || ''} referrer={state?.referrer || ''} list={supplierList?.suppliers || []} />}
      </div>
    </div>
  );
};
